import Link from 'next/link';
import { IInformationItems } from '@features/showroom/typescript';
import styles from '@features/showroom/sections/Information/InformationSection.styles';
import Heading from '@components/Heading/Heading';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  informations: Array<IInformationItems>;
};
const InformationSection = ({
  informations
}: PropsType) => <div sx={styles.informationRow}>
    {informations.map(item => <div sx={styles.informationItem} key={item.id}>
        {item.link ? <Link href={item.link}>
            {item.icon && <div sx={styles.informationIcon}>
                <ResponsiveImage image={item.icon} width={60} height={40} alt="" />
              </div>}
            <Heading h={3} headingType={4} mobile>
              {item.header}
            </Heading>
            {item.text && <p sx={{
        color: 'accent700'
      }}>{item.text}</p>}
          </Link> : <>
            {item.icon && <div sx={styles.informationIcon}>
                <ResponsiveImage image={item.icon} width={60} height={40} alt="" />
              </div>}
            <Heading h={3} headingType={4} mobile>
              {item.header}
            </Heading>
            {item.text && <p>{item.text}</p>}
          </>}
      </div>)}
  </div>;
export default InformationSection;